import { render } from "./college.vue?vue&type=template&id=10f6a954"
import script from "./college.vue?vue&type=script&lang=js"
export * from "./college.vue?vue&type=script&lang=js"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__